export default class UrlHelper {
  static getQueryParam = (url: string, param: string) => {
    const queryParams = new URLSearchParams(url)

    return queryParams.get(param)
  }
}
